import React from 'react';
import { useDragLayer } from 'react-dnd';
import { ItemTypes } from 'constants/reactDnDItemTypes';
import SortingChoicePreview from './SortingChoicePreview';

export function snapToGrid(x, y) {
  const snappedX = 0;
  const snappedY = y;
  return [snappedX, snappedY];
}

function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }
  let { x, y } = currentOffset;
  x -= initialOffset.x;
  y -= initialOffset.y;
  [x, y] = snapToGrid(x, y - 15);
  x += initialOffset.x;
  y += initialOffset.y;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

export const CustomDragLayer = () => {
  const { itemType, isDragging, item, initialOffset, currentOffset } =
    useDragLayer(monitor => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    }));
  function renderItem() {
    switch (itemType) {
      case ItemTypes.CHOICE:
        return <SortingChoicePreview {...item} />;
      default:
        return null;
    }
  }
  if (!isDragging) {
    return null;
  }
  return (
    <div className="SortingQuestion-CustomDragLayer">
      <div style={getItemStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </div>
    </div>
  );
};
